import { RootState } from '../../../../../init-store';
import { getParticipant, getParticipantByIds, selectSortedWaitingRoomPeers } from '../../../../pages/call/selectors';
import { ExtendedNotificationItem } from './types';

export const getNotifications = (state: RootState): ExtendedNotificationItem[] => {
    const waitingRoomPeers = selectSortedWaitingRoomPeers(state);

    return state.notifications.psNotifications.items.map((notificationItem) => {
        const participantId = Object.values(getParticipantByIds(state)).find(
            (participant) => notificationItem?.meta?.userUID && notificationItem?.meta?.userUID === participant?.uid
        )?.id;

        const waitingRoomPeer = waitingRoomPeers.find(({ id }) => notificationItem.meta?.peerId === id);

        return {
            ...notificationItem,
            participant: participantId ? getParticipant(state, participantId) : undefined,
            waitingRoomPeer,
        };
    });
};

export const selectPsNotifications = (state: RootState) => {
    return state.notifications.psNotifications;
};
